import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { ToggleWrapper, SliderWrapper, Input, Slider } from 'src/components/toggle/Toggle.style';

export interface TogglePropsType {
    className?: string;
    toggleActive: () => void;
    isActive: boolean;
    isDisabled?: boolean;
    dataTest?: string;
    variant: 'dark' | 'light';
}

export const Toggle = observer(
    'Toggle',
    ({ className, toggleActive, isActive, isDisabled, dataTest, variant }: TogglePropsType) => {
        return (
            <ToggleWrapper
                className={className}
                isDisabled={isDisabled}
                onClick={toggleActive}
                variant={variant}
            >
                <SliderWrapper data-test={dataTest}>
                    <Input
                        checked={isActive}
                        onChange={toggleActive}
                        type='checkbox'
                        variant={variant}
                    />
                    <Slider variant={variant} />
                </SliderWrapper>
            </ToggleWrapper>
        );
    }
);
